import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import PantherImg from '../../../../../assets/images/warranty/panther.png';
import { incrementStep } from '../redux/actions';

const StepWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 3rem;
  align-items: flex-end;
  border-bottom: 2px solid black;
  img {
    @media (min-width: 1200px) {
      width: 10em;
    }
  }
`;

const PreHeader = styled.h3`
  color: #6d6e6e;
  text-transform: uppercase;
  font-size: 32px;
  line-height: 32px;
`;

const HeaderWrapper = styled.div`
  text-align: right;
  h1 {
    font-size: 50px;
    line-height: 50px;
    letter-spacing: -1px;

    @media (max-width: 767px) {
      font-size: 33px;
      line-height: 33px;
    }
  }

  h1:nth-of-type(2) {
    color: #d40f7d;
  }
`;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 47%;

  @media (max-width: 1200px) {
    width: 60%;
  }

  @media (max-width: 767px) {
    width: 70%;
  }

  button {
    max-width: 9rem;
  }
`;

const FlexEndWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const mapStateToProps = state => ({
  step: state.formData,
});

const Step1 = ({ incrementStep }) => (
  <StepWrapper>
    <img src={PantherImg} />
    <FlexColumn>
      <FlexEndWrapper>
        <PreHeader>Roofing</PreHeader>
        <HeaderWrapper>
          <h1>Standard Warranty</h1>
          <h1>Registration</h1>
        </HeaderWrapper>
      </FlexEndWrapper>
      <p>Congratulations on your new Owens Corning Roof!</p>
      <p>To stay protected for years to come, you can register your standard warranty in a matter of minutes.</p>
      <button
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 1 - get started"
        className="oc-cta-button"
        onClick={() => incrementStep()}
      >
        Get Started
      </button>
    </FlexColumn>
  </StepWrapper>
);

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Step1);
